import {
  SortOrder,
  SortByField,
  buildFieldSortCriterion,
  Sort as SortComponent,
  SortByRelevancy,
} from '@coveo/headless';
import { GridCol, GridRow } from '@lmig/lmds-react-grid';
import { Select, SelectOption } from '@lmig/lmds-react-select';

interface ISortProps {
  sort: React.MutableRefObject<SortComponent>;
  relevanceSortCriterion: React.MutableRefObject<SortByRelevancy>;
  show: boolean;
  queryType: string | undefined;
}

export default function Sort({ sort, relevanceSortCriterion, show, queryType }: ISortProps) {
  const isNewsQuery = queryType?.toLowerCase() === 'news';
  const createdDateDescendingSortCriterion: SortByField = buildFieldSortCriterion('created', SortOrder.Descending);
  const createdDateAscendingSortCriterion: SortByField = buildFieldSortCriterion('created', SortOrder.Ascending);
  const updatedDateDescendingSortCriterion: SortByField = buildFieldSortCriterion('updated', SortOrder.Descending);
  const updatedDateAscendingSortCriterion: SortByField = buildFieldSortCriterion('updated', SortOrder.Ascending);
  const newsPublishedDateDescendingSortCriterion: SortByField = buildFieldSortCriterion(
    'lmcpublishdate',
    SortOrder.Descending,
  );
  const newsPublishedDateAscendingSortCriterion: SortByField = buildFieldSortCriterion(
    'lmcpublishdate',
    SortOrder.Ascending,
  );

  const mapSortCriteriaToOptionValue = (sortCriteria: string | undefined): string => {
    switch (sortCriteria) {
      case 'relevancy':
        return 'relevance';
      case 'created descending':
        return 'createddatedescending';
      case 'created ascending':
        return 'createddateascending';
      case 'updated descending':
        return 'updateddatedescending';
      case 'updated ascending':
        return 'updateddateascending';
      case 'lmcpublishdate descending':
        return 'newspublisheddatedescending';
      case 'lmcpublishdate ascending':
        return 'newspublisheddateascending';
      default:
        return isNewsQuery ? 'newspublisheddatedescending' : 'relevance';
    }
  };

  const selectedSort = mapSortCriteriaToOptionValue(sort.current.state.sortCriteria);

  function handleChange(event: React.FormEvent<HTMLSelectElement>) {
    const selectedSortValue = event.currentTarget.value;
    switch (selectedSortValue) {
      case 'relevance':
        sort.current.sortBy(relevanceSortCriterion.current);
        break;
      case 'createddatedescending':
        sort.current.sortBy(createdDateDescendingSortCriterion);
        break;
      case 'createddateascending':
        sort.current.sortBy(createdDateAscendingSortCriterion);
        break;
      case 'updateddatedescending':
        sort.current.sortBy(updatedDateDescendingSortCriterion);
        break;
      case 'updateddateascending':
        sort.current.sortBy(updatedDateAscendingSortCriterion);
        break;
      case 'newspublisheddatedescending':
        sort.current.sortBy(newsPublishedDateDescendingSortCriterion);
        break;
      case 'newspublisheddateascending':
        sort.current.sortBy(newsPublishedDateAscendingSortCriterion);
        break;
      default:
        break;
    }
  }

  return (
    <>
      {show && (
        <GridRow style={{ alignContent: 'center', alignItems: 'center' }}>
          <GridCol base={3}>
            <div className="bold">Sort By: &nbsp;</div>
          </GridCol>
          <GridCol base={9}>
            {queryType?.toLowerCase() !== 'news' ? (
              <Select
                id="search-page-sort"
                labelVisual=""
                defaultValue={selectedSort}
                onChange={(event: React.FormEvent<HTMLSelectElement>) => handleChange(event)}
              >
                <SelectOption value="relevance">Relevance</SelectOption>
                <SelectOption value="updateddatedescending">Publish date descending</SelectOption>
                <SelectOption value="updateddateascending">Publish date ascending</SelectOption>
              </Select>
            ) : (
              <Select
                id="search-page-sort-news"
                defaultValue={selectedSort}
                onChange={(event: React.FormEvent<HTMLSelectElement>) => handleChange(event)}
                labelVisual=""
              >
                <SelectOption value="relevance">Relevance</SelectOption>
                <SelectOption value="newspublisheddatedescending">Publish date descending</SelectOption>
                <SelectOption value="newspublisheddateascending">Publish date ascending</SelectOption>
              </Select>
            )}
          </GridCol>
        </GridRow>
      )}
    </>
  );
}
